export const ANALYTICS_CONSENT_COOKIE = "tippo_analytics_consent";
export const ANALYTICS_CONSENT_STORAGE_KEY = "tippo.analyticsConsent";

export type TAnalyticsConsent = "granted" | "denied";

function parseConsent(value: string | null | undefined): TAnalyticsConsent | null {
  if (value === "granted" || value === "denied") return value;
  return null;
}

export function getStoredAnalyticsConsent(): TAnalyticsConsent | null {
  try {
    const fromStorage = parseConsent(
      typeof window !== "undefined"
        ? window.localStorage.getItem(ANALYTICS_CONSENT_STORAGE_KEY)
        : null
    );
    if (fromStorage) return fromStorage;
  } catch {
    // ignore
  }

  if (typeof document === "undefined") return null;
  const cookies = document.cookie.split(";").map((c) => c.trim());
  const raw = cookies.find((c) => c.startsWith(`${ANALYTICS_CONSENT_COOKIE}=`));
  const value = raw ? raw.split("=").slice(1).join("=") : null;
  return parseConsent(value);
}

export function setStoredAnalyticsConsent(consent: TAnalyticsConsent): void {
  try {
    window.localStorage.setItem(ANALYTICS_CONSENT_STORAGE_KEY, consent);
  } catch {
    // ignore
  }

  const oneYearSeconds = 60 * 60 * 24 * 365;
  document.cookie = `${ANALYTICS_CONSENT_COOKIE}=${consent}; Max-Age=${oneYearSeconds}; Path=/; SameSite=Lax`;
}

